export const gridClassNames = {
  column: 'column',
  columnGroupHeaderCell: 'column-group-header-cell',
  columnGroupLabel: 'column-group-label',
  contentCell: 'content-cell',
  headerCell: 'header-cell',
  headerCellWithGroup: 'with-group',
  noPadding: 'no-padding',
  row: 'row',
  rowsGroupHeaderRow: 'row-group-sticky-header',
  rowsGroupHeaderRowCell: 'rows-group-header-row-cell',
  rowsGroupHeaderRowContent: 'rows-group-header-row-content',
  scrollWrapper: 'grid-scroll-wrapper',
  selectedRow: 'selected-row',
  pinnedColumn: 'pinned-column',
  pinnedColumnLeft: 'pinned-column-left',
  pinnedColumnRight: 'pinned-column-right',
}
